class ProjectCategories {
  static RESEARCH = 'Research';
  static QUANT_CLUB = 'Quant Club';
  static DEVELOPMENT = 'Development';
  static OTHER = 'Other';

  static OPTIONS = [
    ProjectCategories.RESEARCH,
    ProjectCategories.QUANT_CLUB,
    ProjectCategories.DEVELOPMENT,
    ProjectCategories.OTHER,
  ];
}

export default ProjectCategories;
